module.exports = __webpack_public_path__ + "static/aaiard.b61652c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aaiard.png
// module id = 502
// module chunks = 56712480889174 173894859265406